import { Drawer } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { TicketActionManage } from "./ticket-actionManage";
import { TicketInfoManage } from './ticket-infoManage';

export const TicketActionDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {

    const { id } = useParams<{ id: string }>();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);



    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={(!!id) ? "Update Action" : "Create Action"} onClose={params.onClose} />

            <TicketActionManage onSave={params.onSave}  />
        </Drawer>
    );
};